var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageSize main",style:('background: url('+_vm.imgUrl+') no-repeat;background-size: 100% 100%;')},[_c('div',{staticClass:"footerNum"},[_vm._v("1 of 6")])])
}
var staticRenderFns = []

export { render, staticRenderFns }